module.exports = __webpack_public_path__ + "img/document-code-2.422e4725.svg";